export enum CustomTableColumnType {
  DATE = 'date',
  LINK = 'link',
  BUTTON = 'button',
  BUTTONS = 'buttons',
  INPUT = 'input',
  RADIO = 'radio',
  TEXT = 'text',
  SAVED_CART_PRICE = 'saved_cart_price',
  UPDATE_BUTTON = 'update_button',
  INPUT_INLINE_EDIT = 'input_inline_edit',
  MULTIPLE_LINKS = 'multiple_links'
}
